import PropTypes from 'prop-types';

export const Props = {
  clients: PropTypes.arrayOf(PropTypes.object),
};

export const DefaultProps = {};
